<app-feature-hero
    title="IT Asset <br> Management"
    description="Achieve higher ROI with Infraon’s IT <br> asset management solutions"
    image="/assets/img/feature-pages/infraon-assets/itam/it-lifecycle-hero-img-01-01-01.svg"
    imageAlt="IT Asset Management Hero Image"
></app-feature-hero>

<app-feature-row
    headingLevel="h2"
    heading="What is IT Asset Management (ITAM)?"
    [paragraphs]="whatIsParagraphs"
    image="/assets/img/feature-pages/infraon-assets/itam/itam-feature-image-1.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none;"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="Infraon’s IT Asset Management Solution"
    [paragraphs]="solutionParagraphs"
    image="/assets/img/feature-pages/infraon-assets/itam/itam-feature-image-2.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none;"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="Other Features of Infraon’s IT Asset Management Solution"
    listStyle="check"
    checkIconSize="lg"
    [listItems]="otherFeaturesItems"
    image="/assets/img/feature-pages/infraon-assets/itam/infinity-feature-image-12-01.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none;"
    imagePosition="left"
></app-feature-row>


<section class="section-spacing container">
    <div class="ai-based-itsm ebook d-flex align-items-center justify-content-between primary-bg position-relative">
        <div>
            <small data-aos="fade-up" data-aos-delay="100">EBOOK</small>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">Managing IT Assets in 2024: <br> Trends and Predictions</h2>
            <p data-aos="fade-up" data-aos-delay="500" class="section-paragraph text-start">Explore the impact of technological progress on IT asset management <br> and help future-proof your organization.</p>
            
            <a [routerLink]="['/resources', 'ebook', 'future-of-itam-2026']" class="secondary-buttons cta-buttons rounded-l border">
                <span class="me-1">Download our e-book</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <path d="M10.125 1.375V9.91797L12.6914 7.35156C13.1133 6.89453 13.8516 6.89453 14.2734 7.35156C14.7305 7.77344 14.7305 8.51172 14.2734 8.93359L9.77344 13.4336C9.35156 13.8906 8.61328 13.8906 8.19141 13.4336L3.69141 8.93359C3.23438 8.51172 3.23438 7.77344 3.69141 7.35156C4.11328 6.89453 4.85156 6.89453 5.27344 7.35156L7.875 9.91797V1.375C7.875 0.777344 8.36719 0.25 9 0.25C9.59766 0.25 10.125 0.777344 10.125 1.375ZM2.25 12.625H5.80078L7.38281 14.2422C8.26172 15.1211 9.70312 15.1211 10.582 14.2422L12.1641 12.625H15.75C16.9805 12.625 18 13.6445 18 14.875V16C18 17.2656 16.9805 18.25 15.75 18.25H2.25C0.984375 18.25 0 17.2656 0 16V14.875C0 13.6445 0.984375 12.625 2.25 12.625ZM15.1875 16.2812C15.6445 16.2812 16.0312 15.9297 16.0312 15.4375C16.0312 14.9805 15.6445 14.5938 15.1875 14.5938C14.6953 14.5938 14.3438 14.9805 14.3438 15.4375C14.3438 15.9297 14.6953 16.2812 15.1875 16.2812Z" fill="#0d51d9"/>
                </svg>
            </a>
        </div>
        <img loading="lazy" src="/assets/img/feature-pages/asset-management-ebook.webp" class="asset-mmanagement-ebook m-d-none" alt="asset mmanagement ebook">
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center">Why Use Infraon’s IT Asset <br> Management Solution</h2>

<app-feature-row
    headingLevel="h3"
    heading="Single Solution with One Source of Truth"
    [paragraphs]="singleSolutionParagraph"
    image="/assets/img/feature-pages/infraon-assets/itam/qr-code-feature-img-2-01.png"
    imageAlt="Device discovery charts"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Optimized Resourcing"
    [paragraphs]="optimizedResourcingParagraph"
    image="/assets/img/feature-pages/infraon-assets/itam/qr-code-feature-img-3-01.png"
    imageAlt="maintenance Cost"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="No More Shadow Expenses"
    [paragraphs]="noShadowExpensesParagraph"
    image="/assets/img/feature-pages/infraon-assets/itam/asset-verification-feature-7-01.png"
    imageAlt="Asset verification feature."
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Strengthened Security and Compliance"
    [paragraphs]="strengthenedSecurityParagraph"
    image="/assets/img/feature-pages/infraon-assets/itam/itsm-workflow-management-feature-5-01.png"
    imageAlt="Head office - primary"
    imagePosition="left"
></app-feature-row>
</section>


<app-feature-row
    headingLevel="h2"
    heading="Best Practices for Managing IT Assets"
    [paragraphs]="bestPracticesParagraph"
    listStyle="check"
    checkIconSize="sm"
    [listItems]="bestPracticesItems"
    image="/assets/img/feature-pages/infraon-assets/itam/itam-feature-image-3.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none;"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="Benefits of IT Asset Management"
    [paragraphs]="benefitsParagraph"
    listStyle="check"
    checkIconSize="sm"
    [listItems]="benefitsItems"
    image="/assets/img/feature-pages/infraon-assets/itam/itam-feature-image-4.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none;"
    imagePosition="right"
></app-feature-row>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>

<app-faqs [faqs]="faqs" [theme]="'assets-theme'"></app-faqs>